import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { MaxTimeModifiers } from "@repo/utils";
import { useEstimateEditorSettings, useEstimateStructure } from "@tools";
import { ClearInput } from "@components";
import { Grid, Tooltip } from "@material-ui/core";
import { TransferWorkload } from "@tools/EstimateEditor/components";
import { NumericFormat } from "react-number-format";

export const ChildActions = observer(({
  workType,
  teamMember,
  fullActions,
  previousTeamMember,
  nextTeamMember,
  showActions,
}) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { allowEdition } = useEstimateEditorSettings();

  const {
    usedRoundDecimals,
    usedThousandSeparator,
  } = structure.settings;

  const element = teamMember || workType;
  const {
    hourlyTimeAllocation,
    parsedWorkload,
    isAutomated,
  } = element;

  const handleSetTimeAllocation = (value) => {
    element.setTimelineAllocation(Number(value) * MaxTimeModifiers.HOUR)
  }

  return (
    <>
      {
        fullActions &&
        <Grid
          item container
          wrap="nowrap"
          justifyContent="flex-end"
          alignItems="center"
        >
          {
            showActions &&
            <>
              <Grid
                item container
                className="mr-2 w-max relative"
              >
                {
                  allowEdition && previousTeamMember &&
                  <TransferWorkload
                    workType={workType}
                    source={teamMember}
                    target={previousTeamMember}
                    placement="top"
                    offset
                  />
                }
                <NumericFormat
                  displayType="text"
                  value={parsedWorkload}
                  thousandSeparator={usedThousandSeparator}
                  decimalSeparator="."
                  suffix={t("times.h")}
                  decimalScale={usedRoundDecimals}
                  valueIsNumericString
                />
                {
                  allowEdition && nextTeamMember &&
                  <TransferWorkload
                    workType={workType}
                    source={teamMember}
                    target={nextTeamMember}
                    placement="bottom"
                    offset
                  />
                }
              </Grid>

              <Tooltip
                title={t("views.editor.dialogs.timeline_settings.automated_allocation")}
                disableHoverListener={!isAutomated}
                disableFocusListener={!isAutomated}
                disableTouchListener={!isAutomated}
              >
                <ClearInput
                  value={hourlyTimeAllocation}
                  min={0}
                  max={24}
                  showDecimals
                  onChange={handleSetTimeAllocation}
                  suffix="h/d"
                  fullWidth
                  className="w-56 mr-1"
                  addInitialBorder
                  disabled={isAutomated}
                />
              </Tooltip>
            </>
          }
        </Grid>
      }
    </>
  );
});

ChildActions.propTypes = {
  workType: object,
  teamMember: object,
  previousTeamMember: object,
  nextTeamMember: object,
  showActions: bool,
};
